import { useState } from 'react';
import { SqlEditor } from '@shadcn/components/sql-editor';
import { UsersGrowthChart } from '@shadcn/components/users-growth-chart';
import { Select } from '~/components/ui/Select';

const DEFAULT_LIMIT = 100;
const DEFAULT_SQL = `SELECT * FROM auth.users ORDER BY created_at DESC LIMIT ${DEFAULT_LIMIT};`;

export function UsersManager() {
  const [timeRange, setTimeRange] = useState(90);

  return (
    <div className="pb-8">
      <div className="flex items-center justify-between p-6 pt-4 lg:p-8 lg:pt-8">
        <div className="flex-1">
          <h1 className="text-base lg:text-xl font-semibold">Users</h1>
          <p className="hidden lg:block text-sm lg:text-base text-bolt-ds-textSecondary mt-1">
            View user signups over time
          </p>
        </div>
        <Select
          value={String(timeRange)}
          onValueChange={(value) => setTimeRange(Number(value))}
          placeholder="Select time range"
          containerClassName="w-[160px] sm:ml-auto"
          options={[
            {
              label: 'Last 90 days',
              value: '90',
            },
            {
              label: 'Last 30 days',
              value: '30',
            },
            { label: 'Last 7 days', value: '7' },
          ]}
        />
      </div>
      <div className="px-8">
        <UsersGrowthChart timeRange={timeRange} />
      </div>
      <SqlEditor
        hideChartOption
        initialSql={DEFAULT_SQL}
        defaultLimit={DEFAULT_LIMIT}
        label="Recent users"
        hideSql={true}
        runAutomatically={true}
        readOnly
      />
    </div>
  );
}
